import React from 'react';
import { motion } from 'framer-motion';
import { LightbulbIcon, CheckIcon } from 'lucide-react';
export function BlazerEffect() {
  const effects = ['Tu postura cambia', 'Tu energía cambia', 'La forma en que otros te perciben cambia — antes de que digas una sola palabra'];
  return <section id="solucion" className="py-14 bg-olive-900 text-cream-50" data-id="element-31">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-32">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-33">
          <div className="flex justify-center mb-8" data-id="element-34">
            <div className="p-4 bg-olive-600 rounded-full" data-id="element-35">
              <LightbulbIcon className="h-8 w-8 text-cream-100" strokeWidth={1.5} data-id="element-36" />
            </div>
          </div>

          <h2 className="text-3xl md:text-5xl font-display text-center mb-12" data-id="element-37">
            El "Efecto Blazer Perfecto" <br data-id="element-38" />
            <span className="text-2xl md:text-3xl italic text-olive-100 font-light mt-4 block" data-id="element-39">
              Por qué cambia todo
            </span>
          </h2>

          <div className="space-y-6 text-lg md:text-xl font-light text-cream-100/90 max-w-3xl mx-auto text-center mb-16" data-id="element-40">
            <p data-id="element-41">
              Aquí está lo que las mujeres que siempre se ven impecables saben y
              que nadie más te dice:
            </p>
            <p className="font-medium text-cream-50 text-2xl py-4" data-id="element-42">
              No necesitas 50 prendas. Necesitas las correctas.
            </p>
            <p data-id="element-43">
              Y entre todas las prendas que existen, hay una que hace más
              trabajo por tu imagen que cualquier otra:{' '}
              <span className="font-display italic text-2xl" data-id="element-44">El blazer.</span>
            </p>
            <p data-id="element-45">
              Un blazer bien cortado, en la tela correcta, en el color que
              complementa tu tono de piel y tu personalidad — transforma tu
              presencia completamente.
            </p>
            <p className="text-sm uppercase tracking-widest text-terracotta-400 font-medium pt-4" data-id="element-46">
              No es magia. Es geometría visual y psicología de percepción.
            </p>
          </div>

          <div className="bg-olive-600/30 p-8 md:p-12 border border-olive-600 max-w-2xl mx-auto" data-id="element-47">
            <p className="font-display text-2xl mb-8 text-center" data-id="element-48">
              Cuando entras a una sala con el blazer correcto:
            </p>
            <ul className="space-y-6" data-id="element-49">
              {effects.map((effect, idx) => <motion.li key={idx} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: idx * 0.2
            }} className="flex items-start" data-id="element-50">
                  <CheckIcon className="h-6 w-6 text-terracotta-400 mr-4 flex-shrink-0 mt-1" data-id="element-51" />
                  <span className="text-xl font-light" data-id="element-52">{effect}</span>
                </motion.li>)}
            </ul>
          </div>

          <div className="text-center mt-16" data-id="element-53">
            <p className="text-xl font-light text-cream-100" data-id="element-54">
              Eso es el Efecto Blazer Perfecto. Y combinado con la camisa
              correcta, no solo te ves profesional.
            </p>
            <p className="text-2xl font-display mt-4 text-cream-50" data-id="element-55">
              Te ves como la persona que lidera la sala.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}